// =============================================================================
// modules/example.ts — Módulo de ejemplo
// =============================================================================

document.addEventListener('DOMContentLoaded', () => {
  // Inicializar tooltips de Bootstrap en toda la página
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  tooltipTriggerList.forEach((el) => {
    // Bootstrap 5 usa constructores de instancia; ver documentación oficial.
    // const tooltip = new (window as any).bootstrap.Tooltip(el);
  });

  console.log('Ledger frontend inicializado ✅');
});
